import { AddBoxOutlined } from '@mui/icons-material';
import { Box, Button, InputAdornment, OutlinedInput } from '@mui/material';
import { IconSearch } from '@tabler/icons-react';
import { BodyText, CustomChip, DestinationTable, SubTitleText } from 'Application/components';
import { useDestinationStore } from 'Application/store';
import { FC, useState } from 'react';

interface DestinationsProps {
    addDestinationDialog: () => void;
}

export const Destinations: FC<DestinationsProps> = ({ addDestinationDialog }) => {
    const [searchTerm, setSearchTerm] = useState(''); // Add state for search term

    const { destinationData } = useDestinationStore();
    console.log(destinationData);

    const destinationsCount = destinationData.length;

    const filteredDestinations = destinationData.filter((destination) =>
        destination.destinationName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
    };

    return (
        <Box className="border rounded-xl shadow-sm border-slate-200">
            <Box className="flex flex-wrap justify-between items-center p-6" id="header-section">
                <Box className="flex flex-col space-y-2" id="title-section">
                    <Box className="flex items-end space-x-2">
                        <SubTitleText text={'Destinations'} />
                        <CustomChip text={`${destinationsCount} countries`} />
                    </Box>
                    <BodyText text={'Manage the destinations covered by this product'} />
                </Box>
                <OutlinedInput
                    id="input-search-list-style1"
                    placeholder="Search"
                    className="text-sky-700 border-sky-200 bg-sky-50 rounded-md mt-2 md:mt-0"
                    value={searchTerm} // Bind the search term state
                    onChange={handleSearchChange} // Handle input change
                    startAdornment={
                        <InputAdornment position="start">
                            <IconSearch color="#777" stroke={1.5} size="16px" />
                        </InputAdornment>
                    }
                    size="small"
                />
                <Button
                    onClick={addDestinationDialog}
                    className="text-sky-700 border-sky-200 bg-sky-50 rounded-md mt-2 lg:mt-0"
                    variant="outlined"
                    startIcon={<AddBoxOutlined />}
                >
                    Add Destination
                </Button>
            </Box>
            <DestinationTable data={filteredDestinations} hasCheckboxSelection />
        </Box>
    );
};
